module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "0"
    }
  }, [_c('mu-flexbox-item', {
    staticClass: "subHeader",
    staticStyle: {
      "padding": "8px 8px 4px 8px"
    }
  }, [_c('div', [_vm._v("Select one of your pre-saved meals from the list")])]), _vm._v(" "), _c('mu-list', {
    staticClass: "oddEven"
  }, _vm._l((_vm.meals), function(meal, index) {
    return _c('mu-list-item', {
      key: 'meal-' + index,
      attrs: {
        "disableRipple": ""
      },
      on: {
        "click": _vm.loadFoods
      }
    }, [_vm._o(_c('div', {
      attrs: {
        "slot": "title"
      },
      on: {
        "click": function($event) {
          return _vm.loadMeal(meal)
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(meal.meal_name))]), 0, 'meal-' + index), _vm._v(" "), _c('div', {
      attrs: {
        "slot": "describe"
      },
      on: {
        "click": function($event) {
          return _vm.loadMeal(meal)
        }
      },
      slot: "describe"
    }, [_vm._v("\n        Contains " + _vm._s(meal.count) + " foods\n      ")]), _vm._v(" "), _c('mu-icon-menu', {
      attrs: {
        "slot": "right",
        "icon": "more_vert",
        "scroller": _vm.scroller
      },
      slot: "right"
    }, [_c('mu-menu-item', {
      attrs: {
        "title": _vm.$t('message.deleteText')
      },
      nativeOn: {
        "click": function($event) {
          return _vm.deleteMeal(meal.meal_id)
        }
      }
    })], 1)], 1)
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5559d6f7","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/FoodDiary/MyMeals/MyMeals.vue
// module id = 3179
// module chunks = 1